import React, { useState, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import AdminModal from './AdminModal'; // Import the new AdminModal component

const UserModal = ({ isOpen, onClose, user, onLogout, marketerData, setMarketerData }) => {
    console.log("Marketer Data in UserModal:", marketerData);
    const [twitchDisplayName, setTwitchDisplayName] = useState(marketerData?.twitch_display_name || '');
    const [email, setEmail] = useState(marketerData?.email || '');
    const [name, setName] = useState(marketerData?.name || '');
    const [refid, setRefid] = useState(marketerData?.refid || '');
    const [isAdminModalOpen, setIsAdminModalOpen] = useState(false); // State to control the AdminModal

    useEffect(() => {
        setTwitchDisplayName(marketerData?.twitch_display_name || '');
        setEmail(marketerData?.email || '');
        setName(marketerData?.name || '');
        setRefid(marketerData?.refid || '');
    }, [marketerData]);

    const modalStyle = {
        opacity: isOpen ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out 0.5s',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: isOpen ? 'translate(-50%, -50%)' : 'translate(-50%, -200%)',
        zIndex: 9999,
    };

    const closeModal = (e) => {
        e.stopPropagation();
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!marketerData || !marketerData.id) {
            toast.error("Marketer data not available for update.");
            return;
        }

        try {
            const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
            const adminToken = localStorage.getItem('admin_token'); // Assuming admin_token is stored in localStorage
            const updatedData = {
                twitch_display_name: twitchDisplayName,
                email: email,
                name: name,
                refid: refid,
            };
            const response = await axios.patch(`${backendUrl}/api/all/marketors/${marketerData.id}`, updatedData, {
                headers: { Authorization: `Bearer ${adminToken}` },
            });
            
            if (response.status === 200) {
                toast.success("Profile updated successfully!");
                setMarketerData(response.data); // Update state in App.js
            } else {
                toast.error("Failed to update profile.");
            }
        } catch (error) {
            console.error("Error updating marketer data:", error);
            toast.error("An error occurred while updating profile.");
        }
    };

    const openAdminModal = () => {
        setIsAdminModalOpen(true);
    };

    const closeAdminModal = () => {
        setIsAdminModalOpen(false);
    };

    return (
        <>
            <div className="sync-info-modal" style={modalStyle} onClick={closeModal}>
                <div className="sync-info-modal-header">
                    <div className="sync-info-logo1"></div>
                    <div className="sync-info-logo2"></div>
                    <div className="sync-info-modal-close" onClick={onClose}></div>
                </div>
                <div className="sync-info-modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="info-main-content">
                        <h2>User Information</h2>
                        <form style={{ display: 'flex', flexDirection: 'column', gap: '10px' }} onSubmit={handleSubmit}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="twitch_user_id" style={{ color: '#fbfbfb', fontSize: '1.2vw', marginBottom: '5px' }}>Twitch User ID:</label>
                                <input type="text" id="twitch_user_id" value={marketerData?.twitch_user_id} readOnly 
                                    style={{ 
                                        backgroundColor: '#121a25', 
                                        border: '0.2vw solid #343d49', 
                                        color: '#bdbdbd', 
                                        fontSize: '1.5vw', 
                                        padding: '5px', 
                                        borderRadius: '0.4vw' 
                                    }} 
                                />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="twitch_display_name" style={{ color: '#fbfbfb', fontSize: '1.2vw', marginBottom: '5px' }}>Twitch Display Name:</label>
                                <input type="text" id="twitch_display_name" value={twitchDisplayName} onChange={(e) => setTwitchDisplayName(e.target.value)} 
                                    style={{ 
                                        backgroundColor: '#121a25', 
                                        border: '0.2vw solid #343d49', 
                                        color: '#bdbdbd', 
                                        fontSize: '1.5vw', 
                                        padding: '5px', 
                                        borderRadius: '0.4vw' 
                                    }} 
                                />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="email" style={{ color: '#fbfbfb', fontSize: '1.2vw', marginBottom: '5px' }}>Email:</label>
                                <input type="text" id="email" value={email} onChange={(e) => setEmail(e.target.value)} 
                                    style={{ 
                                        backgroundColor: '#121a25', 
                                        border: '0.2vw solid #343d49', 
                                        color: '#bdbdbd', 
                                        fontSize: '1.5vw', 
                                        padding: '5px', 
                                        borderRadius: '0.4vw' 
                                    }} 
                                />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="name" style={{ color: '#fbfbfb', fontSize: '1.2vw', marginBottom: '5px' }}>Name:</label>
                                <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} 
                                    style={{ 
                                        backgroundColor: '#121a25', 
                                        border: '0.2vw solid #343d49', 
                                        color: '#bdbdbd', 
                                        fontSize: '1.5vw', 
                                        padding: '5px', 
                                        borderRadius: '0.4vw' 
                                    }} 
                                />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="refid" style={{ color: '#fbfbfb', fontSize: '1.2vw', marginBottom: '5px' }}>Ref ID:</label>
                                <input type="text" id="refid" value={refid} onChange={(e) => setRefid(e.target.value)} 
                                    style={{ 
                                        backgroundColor: '#121a25', 
                                        border: '0.2vw solid #343d49', 
                                        color: '#bdbdbd', 
                                        fontSize: '1.5vw', 
                                        padding: '5px', 
                                        borderRadius: '0.4vw' 
                                    }} 
                                />
                            </div>
                            <button type="submit" className="common-but">Update</button>
                        </form>
                        <button onClick={onLogout} className="common-but">Logout</button>
                        <button onClick={openAdminModal} className="common-but">Manage</button>
                    </div>
                </div>
            </div>
            <AdminModal isOpen={isAdminModalOpen} onClose={closeAdminModal} />
        </>
    );
};

export default UserModal;
